// Copyright (c) StrangeBee 2023

import { ReactElement } from 'react';
import { AlertOutput } from 'thehive-sdk';
import RouteBuilder from '@Services/RouteBuilder';
import { ResultCard } from '@Organisms/Search/SearchResultCard/ResultCard';
import { useLocalMessage } from '@Helpers/locale';
import { extractData } from './extractData';
import { ICONS } from '@Constants/iconsApp';

import './AlertResultCard.scss';

interface AlertResultCardProps {
    data?: AlertOutput;
}

export const AlertResultCard = ({ data }: AlertResultCardProps): ReactElement => {
    const i = useLocalMessage();

    const {
        artifacts = [],
        title = '',
        _createdAt = 0,
        description = '',
        source,
        type = '',
        sourceRef = '',
        extraData,
        tags = [],
        severity,
        _id: alertId,
    } = data || {};

    const { importDate = 0 } = extraData || {};

    return (
        <ResultCard
            data={{
                '#computeTitle': {
                    severity,
                    title,
                    path: RouteBuilder.compute('alerts.details', { alertId }),
                    icon: <ICONS.AlertIcon />,
                },
                '#computeDate': {
                    date: importDate || _createdAt,
                },
                '#computeStatus': {
                    status: extraData?.status,
                },
                '#computeInfo': {
                    type,
                    source,
                    sourceRef,
                    artifacts: artifacts.length,
                },
                '#computeDescription': description,
                '#computeTags': tags,
            }}
            extract={extractData({ locale: i })}
        />
    );
};
